import { reportingFactory } from '@eas/common-web';
import { ExportTags } from '../../enums/export-tags';

export const Reporting = reportingFactory({
  exportTag: ExportTags.REPORTING,
});
